"use strict";

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var debug = require("debug")("knack.formatter.formatters.connection");
var checkForHexRegExp = new RegExp("^[0-9a-fA-F]{24}$");
var verifyHex = function verifyHex(val) {
  return checkForHexRegExp.test(String(val));
};

/**
 * @alias "formatters.connection"
 * @param {Object} value Value to be formatted
 * @param {Object} [connFormat] Format options for presenting the address, used for int'l addresses
 * @param {String} [connFormat.separator] How to separate connections, valid values: new_line, comma
 * @param {Boolean} [connFormat.conn_link] Whether to create an anchor tag with href "#${val.id}"
 * @param {String} [responseFormat] Return values format, valid values: html, anything besides 'html'
 * @return {String}
 */
var connectionFormatter = function connectionFormatter(values, connFormat, responseFormat) {
  responseFormat = responseFormat || "html";
  var conn = "";
  var connSeparator = "new_line";
  if (connFormat && connFormat.separator) {
    connSeparator = connFormat.separator;
  }
  var separator;
  if (connSeparator === "comma") {
    separator = responseFormat === "html" ? ", " : ",";
  } else {
    separator = responseFormat === "html" ? "<br />" : "\n";
  }
  if (!values || !values[0] || !values[0].id) {
    return "";
  }
  var _iterator = _createForOfIteratorHelper(values),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var val = _step.value;
      if (val && val.identifier && verifyHex(val.id)) {
        if (responseFormat === "html") {
          var connValue = "<span class=\"".concat(val.id, "\">").concat(val.identifier, "</span>");
          if (connFormat && connFormat.conn_link) {
            connValue = "<a href=\"#".concat(val.id, "\">").concat(connValue, "</a>");
          }
          if (conn !== "") {
            conn += separator;
          }
          conn += connValue; // '<li class="' + val.id + '">' + val.identifier + '</li>';
        } else {
          conn += val.identifier + separator;
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (responseFormat === "html") {

    // conn += '</ul>';
  } else {
    conn = conn.substr(0, conn.length - 1);
  }
  return conn;
};
module.exports = connectionFormatter;